'use strict';

var _createClass = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var TimeoutError = /*#__PURE__*/function (_Error) {
  _inherits(TimeoutError, _Error);

  var _super = _createSuper(TimeoutError);

  function TimeoutError() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Request timed out';

    _classCallCheck(this, TimeoutError);

    _this = _super.call(this, message);
    _this.name = 'TimeoutError';
    return _this;
  }

  return _createClass(TimeoutError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.TimeoutError = TimeoutError;

var AbortError = /*#__PURE__*/function (_Error2) {
  _inherits(AbortError, _Error2);

  var _super2 = _createSuper(AbortError);

  function AbortError() {
    var _this2;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'The operation was aborted.';

    _classCallCheck(this, AbortError);

    _this2 = _super2.call(this, message);
    _this2.name = 'AbortError';
    return _this2;
  }

  return _createClass(AbortError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.AbortError = AbortError;

var HTTPError = /*#__PURE__*/function (_Error3) {
  _inherits(HTTPError, _Error3);

  var _super3 = _createSuper(HTTPError);

  /**
   * @param {Response} response
   */
  function HTTPError(response) {
    var _this3;

    _classCallCheck(this, HTTPError);

    _this3 = _super3.call(this, response.statusText);
    _this3.name = 'HTTPError';
    _this3.response = response;
    return _this3;
  }

  return _createClass(HTTPError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.HTTPError = HTTPError;